var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ctn_nav" }, [
    _c(
      "ul",
      [
        _c("li", [
          _c(
            "div",
            { staticClass: "list_item" },
            [
              _c("router-link", { attrs: { to: { name: "PanelHome" } } }, [
                _c(
                  "div",
                  {
                    staticClass: "mask",
                    class: ["PanelHome" == _vm.getNav ? "active" : "normal"],
                    on: {
                      click: function ($event) {
                        return _vm.actionNav("PanelHome")
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("mdi-rhombus")]),
                    _c("span", [_vm._v("Panel")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._l(_vm.organizedModule, function (item, i) {
          return _c("li", { key: `${item._id}-${i + 1}` }, [
            item.checkModule === true && item.visible === true
              ? _c(
                  "div",
                  { staticClass: "list_item" },
                  [
                    _c("router-link", { attrs: { to: { name: item.route } } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mask",
                          class: [
                            item.route == _vm.getNav ? "active" : "normal",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.actionNav(item.route)
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v(_vm._s(item.icon))]),
                          _c("span", [_vm._v(_vm._s(item.nameModule))]),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ])
        }),
        _vm._l(_vm._modules, function (item, i) {
          return _c("li", { key: `${item._id}-2${i + 1}` }, [
            item.nameModule == "Dispositivos" && item.visible === true
              ? _c(
                  "div",
                  { staticClass: "list_item" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "NotifyHome" } } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "mask",
                            class: [
                              "NotifyHome" == _vm.getNav ? "active" : "normal",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.actionNav("NotifyHome")
                              },
                            },
                          },
                          [
                            _vm.getNotify.check > 0
                              ? _c("div", { staticClass: "circle_noty" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getNotify.check)),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("v-icon", [_vm._v("mdi-bell ")]),
                            _c("span", [_vm._v("Alertas")]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }